<div>
    <div class="circular-progress-container">
        <svg width="150" height="150" viewBox="0 0 120 120" class="circular-progress-svg"
            [ngClass]="{'circular-progress-svg-terminate': progress === 100 || loadingFinished }">
            <circle [attr.r]="radius" cx="60" cy="60" stroke-width="6" class="circular-progress-svg-meter" />
            <circle [style.strokeDasharray]="circumference" [style.strokeDashoffset]="dashoffset" [attr.r]="radius"
                cx="60" cy="60" stroke-width="6" class="circular-progress-svg-value" />
        </svg>
        <div class="circular-progress-percent-container">

            <ng-container *ngIf="!loadingFinished && progress < 100; else checkmarkTemplate">
                <div class="circular-progress-percent" [@fade]>{{progress}}
                    <span class="circular-progress-percent-icon">%</span>
                </div>
            </ng-container>
            <ng-template #checkmarkTemplate>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        style="isolation:isolate" viewBox="1082.46 19.308 313.258 317.704" width="313.258pt"
                        height="317.704pt" class="circular-progress-percent-checkmark">
                        <g>
                            <path class="stroke-1"
                                d=" M 1193.178 158.688 L 1306.178 118.676 C 1321.664 116.945 1325.375 120.719 1331 126 C 1336.625 131.281 1339.312 133.406 1342.178 147.688 C 1344.375 163.031 1344.375 176.906 1341.178 193.688 C 1335.187 215.25 1326.422 231.464 1312.178 247.968 C 1295.719 263.156 1290.348 267.082 1276.178 273.688 C 1259.623 281.405 1243.125 285.25 1225.849 285 C 1217.28 284.876 1209.461 283.133 1199 281"
                                fill="none"   stroke="rgb(0,0,0)"
                                stroke-linejoin="miter" stroke-linecap="round" stroke-miterlimit="4" />
                            <path class="stroke-2"
                                d=" M 1285 197.631 L 1172 237.643 C 1156.514 239.374 1152.803 235.6 1147.178 230.319 C 1141.553 225.038 1138.866 222.913 1136 208.631 C 1133.803 193.288 1133.803 179.413 1137 162.631 C 1142.991 141.069 1151.757 124.856 1166 108.351 C 1182.459 93.163 1187.83 89.237 1202 82.631 C 1218.555 74.914 1235.053 71.069 1252.329 71.319 C 1260.898 71.443 1268.717 73.186 1279.178 75.319"
                                fill="none"   stroke="rgb(0,0,0)"
                                stroke-linejoin="miter" stroke-linecap="round" stroke-miterlimit="4" />
                        </g>
                    </svg>
               
            </ng-template>
        </div>
    </div>
</div>